import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui components
import withStyles from "material-ui/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import teamStyle from "assets/jss/material-kit-react/views/landingPageSections/teamStyle.jsx";

import drugstore from "assets/img/drugstore.jpg";


const imgWrapper = {
  display: 'inline-block',
  position: 'relative',
  width: '30vw',
  height: '30vw',
  overflow: 'hidden',
  borderRadius: '50%',
};

const imageStyle = {
  width: 'auto',
  height: '100%',
  marginLeft: '-50px',
  maxWidth: 'none'
};

const logo = require('assets/img/logo-nodizurc.png');

class TeamSection extends React.Component {
  render() {
    const { classes } = this.props;
    const brand = <img src={logo} alt="product logo" width="100px" />;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgFluid
    );
    return (
      <div className={classes.section} id="location">
        <h2 className={classes.title}>A Loja</h2>
        <h3 className={classes.description}>
          Drogaria Lisbonense
        </h3>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                className={classes.itemGrid}
                style={imgWrapper}
              >
                <img
                  src={drugstore}
                  alt="drugstore-lisbonense"
                  className={imageClasses}
                  style={imageStyle}
                />
              </GridItem>
              {/* <h4 className={classes.cardTitle}>
                Localização pode ter várias linhas mas não vai afetar assim tanto
                <br />
                <small className={classes.smallTitle}>Model</small>
              </h4> */}
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <p className={classes.description}>
                A drogaria Lisbonense localizada em São João da Madeira é um estabelecimento comercial especializado na venda de produtos produtos químicos, destacando-se a gama de produtos {brand}, e outro tipo de produtos deste utilitários para as casas a pequenos produtos de construção e reparações.
                <br/>
                <br/>
                <strong>Localização: </strong>
                <span>Rua Oliveira Júnior 568 S, São João Da Madeira, Aveiro, 3700-025 São João da Madeira</span>
                <br/>
                <br/>
                <strong>Horário de Funcionamento: </strong>
                <span>Segunda a Sábado das 9h às 18h</span>
                <br/>
                <br/>
                <strong>Contacto: </strong>
                <span>256 831 621</span>
              </p>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(teamStyle)(TeamSection);



// WEBPACK FOOTER //
// ./src/views/Nodizurc/Sections/TeamSection.jsx